export function normalizePeriodInMonths(period, unit) {
  const numericPeriod = Number(period);
  const safePeriod = Number.isFinite(numericPeriod) && numericPeriod > 0 ? numericPeriod : 1;
  const normalizedUnit = String(unit || 'month').trim().toLowerCase();

  if (normalizedUnit.startsWith('year')) {
    return safePeriod * 12;
  }
  if (normalizedUnit.startsWith('month')) {
    return safePeriod;
  }
  if (normalizedUnit.startsWith('week')) {
    return (safePeriod * 7) / 30;
  }
  if (
    normalizedUnit.startsWith('day') ||
    normalizedUnit.startsWith('daily')
  ) {
    return safePeriod / 30;
  }

  return safePeriod;
}

export function toNumericAmount(value) {
  if (value == null) {
    return null;
  }
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }
  const numeric = Number(String(value).replace(/[^0-9.]/g, ''));
  return Number.isFinite(numeric) ? numeric : null;
}

export function calculateMonthlyPriceAmount(priceAmount, period, unit) {
  const numericPrice = toNumericAmount(priceAmount);
  if (!Number.isFinite(numericPrice)) {
    return 0;
  }
  const months = normalizePeriodInMonths(period, unit);
  const safeMonths = months > 0 ? months : 1;
  return numericPrice / safeMonths;
}

export function formatCurrencyAmount(amount, options = {}) {
  const numericAmount = Number(amount);
  const {
    minimumFractionDigits = 0,
    maximumFractionDigits = 2,
  } = options;

  if (!Number.isFinite(numericAmount)) {
    return '฿0';
  }

  return `฿${numericAmount.toLocaleString('en-US', {
    minimumFractionDigits,
    maximumFractionDigits,
  })}`;
}

export function normalizeCurrencyText(value) {
  const raw = String(value || '').trim();
  if (!raw) {
    return '';
  }

  if (!/[0-9]/.test(raw)) {
    return raw.replace(/US\$/gi, '฿').replace(/\$/g, '฿');
  }

  const match = raw.match(/^(.*?)(?:US\$|\$|฿)?\s*(\d[\d,]*(?:\.\d+)?)\s*(.*)$/i);
  if (!match) {
    return raw.replace(/US\$/gi, '฿').replace(/\$/g, '฿');
  }

  const [, prefixRaw, amountRaw, suffixRaw] = match;
  const amount = toNumericAmount(amountRaw);
  if (!Number.isFinite(amount)) {
    return raw.replace(/US\$/gi, '฿').replace(/\$/g, '฿');
  }

  const prefix = String(prefixRaw || '').trim();
  const suffix = String(suffixRaw || '')
    .replace(/\s*\/\s*/g, ' / ')
    .replace(/\s+/g, ' ')
    .trim();

  const normalizedPrefix = prefix ? `${prefix} ` : '';
  const normalizedSuffix = suffix ? ` ${suffix}` : '';

  return `${normalizedPrefix}${formatCurrencyAmount(amount)}${normalizedSuffix}`.trim();
}

export function formatMonthlyPrice(priceAmount, period, unit) {
  const monthlyAmount = calculateMonthlyPriceAmount(priceAmount, period, unit);
  if (!Number.isFinite(monthlyAmount)) {
    return '฿0 / month';
  }
  return `${formatCurrencyAmount(monthlyAmount)} / month`;
}
